
































































import { Component, Vue } from 'vue-property-decorator'
import ListInformationsAdditionnelles from '@/views/informationAdditionnelles/ListBasicInformationsAdditionnelles.vue'

@Component({
  components: {
    ListInformationsAdditionnelles,
  },
})
export default class Home extends Vue {}
